// extracted by mini-css-extract-plugin
export default {"root":"stored_as_cell-module___root___e3bf599b","iconContainer":"stored_as_cell-module___iconContainer___ebfbd67e","icon":"stored_as_cell-module___icon___fc506aa7"};